/* unplugin-vue-components disabled */import script from "./StoreList.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreList.vue?vue&type=script&setup=true&lang=js"

import "./StoreList.vue?vue&type=style&index=0&id=3d905fc4&lang=scss"

const __exports__ = script;

export default __exports__